import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLLMModalOpen, setSelectedLLM } from "slices/app/reducer";
import openaiLogo from "images/llms/openai.jpg";
import anthropicLogo from "images/llms/anthropic.jpg";
import mistralLogo from "images/llms/mistral.jpg";
import geminiLogo from "images/llms/gemini.jpg";

const LLM_OPTIONS = [
    {
        label: "OpenAI",
        value: "Openai",
        icon: openaiLogo
    },
    {
        label: "Anthropic",
        value: "anthropic",
        icon: anthropicLogo
    },
    {
        label: "Mistral",
        value: "mistral",
        icon: mistralLogo
    },
    {
        label: "Gemini",
        value: "Gemini",
        icon: geminiLogo
    }
];

const LLMSelectModal = () => {
    const dispatch = useDispatch();
    const { isLLMModalOpen, selectedLLM } = useSelector((state) => state.AppReducer);

    const closeModal = () => {
        dispatch(setIsLLMModalOpen(false));
    };

    const handleSelect = (option) => {
        dispatch(setSelectedLLM(option));
        closeModal();
    };

    if (!isLLMModalOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-[#0F172A]  rounded-lg shadow-lg w-full max-w-2xl p-6">
                <div className="mb-4">
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-white">Select an LLM</h2>
                        <button onClick={closeModal} className="text-white text-3xl">×</button>
                    </div>
                    <div className="mt-2 h-px w-full bg-[#334155]" />
                </div>
                <div className="p-4 py-10 grid grid-cols-2 gap-4 sm:grid-cols-2 xs:grid-cols-1">
                    {LLM_OPTIONS.map((option) => (
                        <button
                            key={option.value}
                            onClick={() => handleSelect(option)}
                            className={`flex items-center px-4 py-3 rounded-lg text-white transition-colors w-full h-16 focus:outline-none border border-[#232B3A] ${selectedLLM?.value === option.value ? "bg-violet-700 border-violet-500" : "bg-[#1E293B] hover:bg-violet-800"}`}
                        >
                            <img src={option.icon} alt={option.label} className="h-8 w-8 mr-4" />
                            <span className="text-lg font-medium flex-1 text-left">{option.label}</span>
                            {selectedLLM?.value === option.value && (
                                <span className="ml-2 text-green-400 font-semibold">✓</span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
            <style jsx>{`
        @media (max-width: 640px) {
          .grid-cols-2 {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
        </div>
    );
};

export default LLMSelectModal; 